import React from 'react';
import { Icon } from '../../components/sp-primitives';

function fmtCreditorKpi(creditorKpisLoading, n) {
  if (creditorKpisLoading || n === null || n === undefined || Number.isNaN(Number(n))) return '—';
  return Number(n).toLocaleString('pt-BR');
}

export function CreditorKpisSyncBar({
  creditorKpisErr,
  creditorKpis,
  creditorKpisLoading,
  syncQueueActive,
  syncTotalModalOpen,
  syncTotalRunning,
  onSyncTotal,
}) {
  return (
    <>
      {creditorKpisErr && (
        <div className="sp-creditors-kpis-err" role="status">
          {creditorKpisErr}
        </div>
      )}
      <div className="sp-creditors-kpi-strip" aria-label="Indicadores de credores">
        <div className="sp-creditors-kpi-grid">
          <div className="sp-card sp-creditors-kpi-tile">
            <div className="sp-dash-kpi-label">Total de Credores</div>
            <div className="sp-num sp-dash-kpi-value">{fmtCreditorKpi(creditorKpisLoading, creditorKpis?.total_creditors)}</div>
          </div>
          <div className="sp-card sp-creditors-kpi-tile">
            <div className="sp-dash-kpi-label">Fornecedores</div>
            <div className="sp-num sp-dash-kpi-value">{fmtCreditorKpi(creditorKpisLoading, creditorKpis?.suppliers)}</div>
          </div>
          <div className="sp-card sp-creditors-kpi-tile">
            <div className="sp-dash-kpi-label">Funcionários</div>
            <div className="sp-num sp-dash-kpi-value">{fmtCreditorKpi(creditorKpisLoading, creditorKpis?.employees)}</div>
          </div>
          <div className="sp-card sp-creditors-kpi-tile sp-creditors-kpi-tile--payments">
            <div className="sp-dash-kpi-label">Total de pagamentos sincronizados</div>
            <div className="sp-creditors-kpi-sublabel">Últimos 30 dias</div>
            <div className="sp-num sp-dash-kpi-value">
              {fmtCreditorKpi(creditorKpisLoading, creditorKpis?.payments_synced_last_30_days)}
            </div>
          </div>
        </div>
      </div>
      <div className="sp-creditors-sync-bar">
        {syncQueueActive && (
          <div className="sp-creditors-sync-alert" role="status">
            Aguarde atualização de Credores, existem tarefas de Sincronização em andamento.
          </div>
        )}
        <button
          type="button"
          className="sp-btn sp-btn-outline"
          disabled={syncTotalModalOpen || syncQueueActive}
          onClick={onSyncTotal}
        >
          <Icon name="history" size={14} /> {syncTotalRunning ? 'A sincronizar…' : 'Sincronização Total'}
        </button>
      </div>
    </>
  );
}
